import { IconName } from "@blueprintjs/core";

import Class from "core/util/Class";
import TypedRegistry from "core/util/TypedRegistry";
import { Article } from "./entities";

export interface IArticleTypeComponentProps<T> {
	readonly article: Article;
	uiSchema: T;

	contributorDisplay?: JSX.Element;
	attachmentDisplay?: JSX.Element;
}

export interface IArticleType<T = any> {
	type: string;
	label: string;
	icon: IconName;
	component: React.ComponentType<IArticleTypeComponentProps<T>>;
	configClass?: Class<T>;
}

export const ArticleTypeRegistry = new TypedRegistry<IArticleType>((o) => o.type);



// WEBPACK FOOTER //
// ./src/panels/kb/article/IArticleType.ts